import { z } from 'zod';
import { getMutationSchema } from '../../../../ui/util/getMutationSchema';
import { ResourceType } from '../../../enumerations/ResourceType';
import { useIndirectlyVersionedResourceAdapter } from '../../../resource-base/adapters/useIndirectlyVersionedResourceAdapter';
import { useMultiResourceSingleParentedResourceAdapterActions } from '../../../resource-base/adapters/useMultiResourceSingleParentedResourceAdapterActions';
import {
    defaultIndirectlyVersionedArtifactResource,
    IndirectlyVersionedArtifactResourceSchema,
} from '../../../resource-base/artifactResourceTypes';
import { IdSchema } from '../../../resource-base/baseSchemas';

export enum ProcessAreaObjectiveAssociationPropertyValidation {
    OBJECTIVE = 'OBJECTIVE',
}

export const ProcessAreaObjectiveAssociationResourceSchema = IndirectlyVersionedArtifactResourceSchema.extend({
    resourceType: z
        .literal(ResourceType.PROCESS_AREA_OBJECTIVE_ASSOCIATION)
        .default(ResourceType.PROCESS_AREA_OBJECTIVE_ASSOCIATION),
    objective: IdSchema,
});
export const ProcessAreaObjectiveAssociationMutationResourceSchema = getMutationSchema(
    ProcessAreaObjectiveAssociationResourceSchema
);

export type ProcessAreaObjectiveAssociationResource = z.infer<typeof ProcessAreaObjectiveAssociationResourceSchema>;

export const defaultProcessAreaObjectiveAssociationResource: ProcessAreaObjectiveAssociationResource = {
    ...defaultIndirectlyVersionedArtifactResource,
    resourceType: ResourceType.PROCESS_AREA_OBJECTIVE_ASSOCIATION,
    objective: '',
};

export function useProcessAreaObjectiveAssociationActions() {
    return {
        ...useMultiResourceSingleParentedResourceAdapterActions(
            'project/process-area-objective-association',
            ResourceType.PROCESS_AREA_OBJECTIVE_ASSOCIATION,
            ProcessAreaObjectiveAssociationResourceSchema
        ),
        ...useIndirectlyVersionedResourceAdapter(
            'project/process-area-objective-association',
            ResourceType.PROCESS_AREA_OBJECTIVE_ASSOCIATION,
            ProcessAreaObjectiveAssociationResourceSchema
        ),
    };
}
